module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headerTooltip":"The chart presents an average price in time in stores displayed in the widget (default settings).To check the average price in time in other stores, use the filter selected stores.This value is calculated as the sum of prices from all days, divided by the number of days for which price information is available and it is higher than 0."}}')
  delete Component.options._Ctor
}
